import React from 'react';

export const Education = ({educations}) => {
    return (
        <ul>
            {educations.map((edu, index) => (
                <li key={index}>
                    <span className="date">{edu.date}</span><br/>
                    <span className="title">{edu.title}</span><br/>
                    <span className="affiliation">
                        <a href={edu.affiliation.url} target="_blank" rel="noopener noreferrer">
                            {edu.affiliation.name}
                        </a>
                    </span><br />
                    <span className="description">{edu.description}</span>
                </li>
            ))}
        </ul>
    );
};